if (document.querySelector("[data-kids-love-taste-section]")) {
    const kidsLoveTasteSection = document.querySelector("[data-kids-love-taste-section]");
    const kidsLoveTasteLottiePlayer = kidsLoveTasteSection.querySelector("[data-klt-lottie-player]");
    const kidsLoveTasteCharacters = [...kidsLoveTasteSection.querySelectorAll("[data-klt-character]")];
    const kidsLoveTasteAnglesBlueCharacter = kidsLoveTasteSection.querySelector("[data-klt-angle-blue-character]");
    const kidsLoveTasteSea = kidsLoveTasteSection.querySelector("[data-klt-sea]");
    const kidsLoveTasteBeach = kidsLoveTasteSection.querySelector("[data-klt-beach]");
    const kidsLoveTasteClouds = kidsLoveTasteSection.querySelector("[data-klt-clouds]");

    const kidsLoveTasteLottieFileUrl = window.innerWidth > 1300 ? kidsLoveTasteLottiePlayer.dataset.src : kidsLoveTasteLottiePlayer.dataset.srcMobile;

    // lazy loading for images and lottie animations
    lazyLoadSectionFiles(kidsLoveTasteSection, 
    kidsLoveTasteSection.querySelectorAll("[data-lazy-loading-image]"), 
    undefined, [
      { lottiePlayer: kidsLoveTasteLottiePlayer, lottieFileName: kidsLoveTasteLottieFileUrl }
    ]);

    // parallax or vibrate effect
    let kidsLoveTasteBeachParallax, kidsLoveTasteCloudsParallax, kidsLoveTasteAnglesBlueCharacterParallax, kidsLoveTasteSeaParallax, kidsLoveTasteCharactersParallax;
    const platform = determinePlatform();
    if (platform === 'mac' || platform === 'ios') {
      // vibrate effect for the elements in the section on mac and IOS devices (instead of parallax)
      
    } else {
      // parallax
      kidsLoveTasteCharactersParallax = kidsLoveTasteCharacters.map(character => {
        if (character.dataset.kltCharacter === "stick") {
          return new ElementParallax(kidsLoveTasteSection, character, { y: 15 }, 0, { y: -5 }, 2.5);
        }
    
        if (window.innerWidth > 1300) {
          if (character.dataset.kltCharacter === "prophy" || character.dataset.kltCharacter === "mint") {
            return new ElementParallax(kidsLoveTasteSection, character, { y: 15 }, 0, { y: -6 }, 2.5);
          }

          return new ElementParallax(kidsLoveTasteSection, character, { y: 15 }, 0, { y: -10 }, 2.5);
        } else {
          return new ElementParallax(kidsLoveTasteSection, character, { y: 15 }, 0, { y: -4 }, 2.5);
        }
      });

      if (window.innerWidth > 1300) {
        kidsLoveTasteAnglesBlueCharacterParallax = new ElementParallax(kidsLoveTasteSection, kidsLoveTasteAnglesBlueCharacter, { y: -5 }, 0, { y: 7 }, 2.5);
        kidsLoveTasteSeaParallax = new ElementParallax(kidsLoveTasteSection, kidsLoveTasteSea, { y: -5 }, 0, { y: 7 }, 2.5);
        kidsLoveTasteBeachParallax = new ElementParallax(kidsLoveTasteSection, kidsLoveTasteBeach, { y: -5 }, 0, { y: 7 }, 4);

        window.addEventListener("load", handleParallax);
        window.addEventListener("scroll", handleParallax);
      }
    }
  
    if (window.innerWidth < 1300) {
      kidsLoveTasteAnglesBlueCharacterParallax = new ElementParallax(kidsLoveTasteSection, kidsLoveTasteAnglesBlueCharacter, { x: 0, y: 0 }, 0, { x: 50, y: -10 }, 4);
      kidsLoveTasteSeaParallax = new ElementParallax(kidsLoveTasteSection, kidsLoveTasteSea, { x: 0 }, 0, { x: 24 }, 4);
      kidsLoveTasteCloudsParallax = new ElementParallax(kidsLoveTasteSection, kidsLoveTasteClouds, { x: 50 }, 0, { x: 0 }, 4);

      window.addEventListener("load", handleParallax);
      window.addEventListener("scroll", handleParallax);
    }
  
    function handleParallax() {
      const currentScroll = document.documentElement.scrollTop;
  
      kidsLoveTasteCharactersParallax?.forEach(characterParallax => characterParallax.apply(currentScroll));
      kidsLoveTasteAnglesBlueCharacterParallax.apply(currentScroll);
      kidsLoveTasteSeaParallax.apply(currentScroll);
      if (window.innerWidth > 1300) {
        kidsLoveTasteBeachParallax?.apply(currentScroll);
      } else {
        kidsLoveTasteCloudsParallax.apply(currentScroll);
      }
    }
  
    // lottie
    let kidsLoveTasteSectionWasAlreadyInViewport = false;
  
    function reloadPlayer(player) {
      player.load(kidsLoveTasteLottieFileUrl);
    
      player.addEventListener('ready', () => {
        player.play();
        player.setSpeed(1.4);
      });
    }

    function addKidsLoveTasteObserver() {
      const addKidsLoveTasteObserver = new IntersectionObserver(entries => {
        const sectionEntry = entries[0];
  
        if (sectionEntry.isIntersecting && kidsLoveTasteSectionWasAlreadyInViewport === false) {
          kidsLoveTasteSectionWasAlreadyInViewport = true;
          reloadPlayer(kidsLoveTasteLottiePlayer);
        } else {
          kidsLoveTasteSectionWasAlreadyInViewport = false;
        }
      }, {
        threshold: 0.6
      });
      addKidsLoveTasteObserver.observe(kidsLoveTasteSection);
    }

    window.addEventListener("load", () => {
      kidsLoveTasteLottiePlayer.load(kidsLoveTasteLottieFileUrl);
  
      kidsLoveTasteLottiePlayer.addEventListener('ready', () => {
        addKidsLoveTasteObserver();
      }, { once: true });
    });
  }